// extracted by mini-css-extract-plugin
export default {"container":"styles_container__UqW-7","title":"styles_title__A3nZJ","desc":"styles_desc__IOK9D","title-head":"styles_title-head__aOLuV","desc-head":"styles_desc-head__CMvmO"};